import { useState, useCallback } from 'react';

/**
 * Hover controls utility for graphics elements in left panel.
 * todo: Rename and move to bokeh menu.
 */
export function useSourceHoverControls() {
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);
  const [isItemHoveredInternal, setItemHoveredInternal] = useState<boolean>(false);
  const [isItemHovered, setItemHovered] = useState<boolean>(false);

  const onMouseEnter = useCallback(() => {
    setItemHovered(true);
    setItemHoveredInternal(true);
  }, []);

  const onMouseHover = useCallback(() => {
    setItemHovered(true);
    setItemHoveredInternal(true);
  }, []);

  const onMouseLeave = useCallback(() => {
    setItemHoveredInternal(false);

    if (!isMenuOpen) {
      setItemHovered(false);
    }
  }, [isMenuOpen]);

  const onCloseMenu = useCallback(() => {
    setMenuOpen(false);

    if (!isItemHoveredInternal) {
      setItemHovered(false);
    }
  }, [isItemHoveredInternal]);

  const onToggleMenu = useCallback(() => {
    const nextMenuState: boolean = !isMenuOpen;

    setMenuOpen(nextMenuState);

    if (!nextMenuState && isItemHoveredInternal) {
      setItemHovered(false);
    }
  }, [isItemHoveredInternal, isMenuOpen]);

  return {
    onMouseEnter,
    onMouseLeave,
    onMouseHover,
    onCloseMenu,
    onToggleMenu,
    isMenuOpen,
    isItemHovered,
  };
}
